export const ApiConstant = {
    APP_NAME: "CMS - CORPORATE",
    API_BASEURL: (process.env.React_APP_API_URL) ? process.env.React_APP_API_URL : "http://felis-api.plansynergy.com/:9016/v1/",
    PLATEFORM: "WEB",
    API_KEY: "NANDAN_OPERATION_WEB_2022",
    APP_ID: "1"
}